import React from 'react';
import PropTypes from 'prop-types';
import MuiAccordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { Translate } from 'react-redux-i18n';
import { withStyles } from '@material-ui/core';
import InviteeView from '../invitee/InviteeView';
import { PROJECT_ORGANISATION_ROLE as role } from '../../../../../utils/constant';
import ParticipantView from '../participant/ParticipantView';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ParticipantsAccordionView = props => {
  if (!props.participants.length && !props.invitations.length) {
    return null;
  }
  const participantsWithInvitees = [...props.participants, ...props.invitations];
  const sortedParticipants = participantsWithInvitees?.sort((a, b) => (a.organisation?.fullName || a.organisationName) < (b.organisation?.fullName || b.organisationName) ? -1 : (a.organisation?.fullName || a.organisationName) > (b.organisation?.fullName || b.organisationName) ? 1 : 0);
  const participantsAccordion = sortedParticipants.length > 1 ? sortedParticipants.map((participant, index) => {
    if (participant.organisation) {
      return /*#__PURE__*/_jsx(ParticipantView, {
        role: participant.role,
        organisationName: participant.organisation.fullName,
        registrationNumber: participant.organisation.registrationNumber,
        authorizedActions: {
          authorizedActions: props.authorizedActions,
          isRemovable: participant.isRemovable
        },
        onRemoveGC: () => props.onRemoveGC(participant.id),
        isInAccordion: true
      }, index);
    }
    return /*#__PURE__*/_jsx(InviteeView, {
      status: participant.status,
      role: participant.role,
      organisationName: participant.organisationName,
      registrationNumber: participant.registrationNumber,
      onlyBottomBorder: true,
      authorizedActions: props.authorizedActions,
      onRemoveGCInvitee: () => props.onRemoveGCInvitee(participant.id),
      isInAccordion: true
    }, index.toString());
  }) : null;
  const Accordion = withStyles({
    root: {
      boxShadow: 'none',
      '&:before': {
        display: 'none'
      }
    }
  })(MuiAccordion);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: participantsAccordion && /*#__PURE__*/_jsxs(Accordion, {
      className: "box border bottom",
      children: [/*#__PURE__*/_jsx(AccordionSummary, {
        className: "p-0",
        expandIcon: /*#__PURE__*/_jsx("span", {
          className: "caret-drop"
        }),
        "aria-controls": "panel1a-content",
        id: "panel1a-header",
        children: /*#__PURE__*/_jsxs("h3", {
          children: [/*#__PURE__*/_jsx(Translate, {
            value: `project.role.${role.PROJECT_GENERAL_CONTRACTOR}.plural`
          }), /*#__PURE__*/_jsx("span", {
            className: "separator information",
            children: participantsWithInvitees.length
          })]
        })
      }), /*#__PURE__*/_jsx(AccordionDetails, {
        className: "row p-0",
        children: participantsAccordion
      })]
    })
  });
};
ParticipantsAccordionView.propTypes = {
  participants: PropTypes.array,
  invitations: PropTypes.array,
  authorizedActions: PropTypes.bool.isRequired,
  onRemoveGCInvitee: PropTypes.func.isRequired,
  onRemoveGC: PropTypes.func
};
export default ParticipantsAccordionView;